/**
 * @todo This should be exported from @ftdr/blueprint_core
 * and auto generated based on class names used in component_css
 */
export const CSS_CLASSES = {
  LINK: "link",

  LINK_BOLD: "link-bold",

  LINK_UNDERLINE_HOVER: "link-underline-hover",
  LINK_UNDERLINE_ALWAYS: "link-underline-always",

  LINK_COLOR_PRIMARY: "link-color-primary",
  LINK_COLOR_SECONDARY: "link-color-secondary",
  LINK_COLOR_INTERACTIVE: "link-color-interactive",
  LINK_COLOR_ACCENT: "link-color-accent",
  LINK_COLOR_GRAY: "link-color-gray",
  LINK_COLOR_ERROR: "link-color-error",
  LINK_COLOR_WARNING: "link-color-warning",
  LINK_COLOR_SUCCESS: "link-color-success",
  LINK_COLOR_WHITE: "link-color-white",
  LINK_COLOR_BLACK: "link-color-black",

  LINK_ICON: "link-icon",
  LINK_START_ICON: "link-start-icon",
  LINK_END_ICON: "link-end-icon",
};
